import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import RyanVideo from "../../assets/videos/introduction.mp4";

const MainContent = () => {
  return (
    <video className="introduction-section" controls>
      <source src={RyanVideo} type="video/mp4" />
    </video>
  );
};

const IntroductionPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="INTRODUCTION"
          stringBlurb="Welcome to iCXeed! We're thrilled to embark on this journey with you.
          Here, you'll find essential information about our talent onboarding and
          development system, governance framework, and information security
          practices to help you seamlessly integrate into our ecosystem of business
          process innovation."
          previousBtn="/"
          nextBtn="/our-team"
          mainContent={<MainContent />}
          disablePreviousBtn={true}
        />
      </div>
    </div>
  );
};

export default IntroductionPage;
